import { render, staticRenderFns } from "./EditLocation.vue?vue&type=template&id=0b2ab938&"
import script from "./EditLocation.vue?vue&type=script&lang=js&"
export * from "./EditLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports